<!-- Il marchio, ricostruito a primitive (rect, circle, polyline) come in
     libs/infra/branding/resources/logo.svg. I due "buchi" — interno del calendario e centro
     dell'ingranaggio — sono <mask>, non <path>. -->
<svg
  class="block h-[1em] w-[1em]"
  viewBox="70.1 68.6 1194.7 1194.7"
  xmlns="http://www.w3.org/2000/svg"
>
  <defs>
    <mask [attr.id]="calendarMaskId">
      <rect
        width="1254"
        height="1254"
        fill="#fff"
      />
      <rect
        x="210"
        y="891"
        width="824"
        height="172"
        rx="86"
        fill="#000"
      />
      <rect
        x="210"
        y="431"
        width="824"
        height="546"
        fill="#000"
      />
      <rect
        x="297"
        y="155"
        width="167"
        height="211"
        rx="80"
        fill="#000"
      />
      <rect
        x="780"
        y="155"
        width="167"
        height="211"
        rx="80"
        fill="#000"
      />
      <!-- il distacco attorno all'ingranaggio: stessa sagoma, allargata -->
      <circle
        cx="906"
        cy="908"
        r="238"
        fill="#000"
      />
      @for (angle of teeth; track angle) {
        <rect
          x="829"
          y="604"
          width="154"
          height="106"
          rx="46"
          fill="#000"
          [attr.transform]="'rotate(' + angle + ' 906 908)'"
        />
      }
    </mask>

    <mask [attr.id]="gearMaskId">
      <rect
        width="1254"
        height="1254"
        fill="#fff"
      />
      <circle
        cx="906"
        cy="908"
        r="145"
        fill="#000"
      />
    </mask>
  </defs>

  <g>
    <rect
      x="147"
      y="238"
      width="951"
      height="886"
      rx="142"
      fill="#A855F7"
      [attr.mask]="'url(#' + calendarMaskId + ')'"
    />
    <rect
      x="281"
      y="510"
      width="124"
      height="120"
      rx="27"
      fill="#E9D5FF"
    />
    <rect
      x="281"
      y="683"
      width="124"
      height="120"
      rx="27"
      fill="#E9D5FF"
    />
    <rect
      x="281"
      y="859"
      width="124"
      height="120"
      rx="27"
      fill="#E9D5FF"
    />
    <rect
      x="457"
      y="510"
      width="124"
      height="120"
      rx="27"
      fill="#E9D5FF"
    />
    <rect
      x="457"
      y="683"
      width="124"
      height="120"
      rx="27"
      fill="#E9D5FF"
    />
    <rect
      x="457"
      y="859"
      width="124"
      height="120"
      rx="27"
      fill="#E9D5FF"
    />
    <rect
      x="638"
      y="510"
      width="124"
      height="120"
      rx="27"
      fill="#E9D5FF"
    />
  </g>

  <!-- le due linguette che escono dal bordo superiore -->
  <rect
    x="320"
    y="142"
    width="122"
    height="198"
    rx="61"
    fill="#A855F7"
  />
  <rect
    x="803"
    y="142"
    width="122"
    height="198"
    rx="61"
    fill="#A855F7"
  />

  <g [attr.mask]="'url(#' + gearMaskId + ')'">
    <circle
      cx="906"
      cy="908"
      r="216"
      fill="#A855F7"
    />
    @for (angle of teeth; track angle) {
      <rect
        x="851"
        y="626"
        width="110"
        height="106"
        rx="24"
        fill="#A855F7"
        [attr.transform]="'rotate(' + angle + ' 906 908)'"
      />
    }
  </g>

  <polyline
    points="825,900 885,965 990,855"
    fill="none"
    stroke="#22C55E"
    stroke-width="58"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
